module.exports = __webpack_public_path__ + "img/logo_top.fd389670.svg";